import React from "react";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface EditButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onClick: () => void;
}

const EditButton: React.FC<EditButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onClick,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="edit-button"
      testId="edit-button"
      variant="contained"
      onClick={onClick}
    />
  );
};
export default EditButton;
